import styles from "./PromoSection.module.css";
import copy from "./copy.svg";
import {pluralize} from "@/shared/lib/pluralize/pluralize.js";
import {toast} from "react-toastify";

export default function PromoSection({code = '', count = 0}) {
    return (
        <section className={`container-custom`}>
            <p className={`section-title`}>Персональный промокод</p>
            <div className={`row g-0 ${styles.cards}`}>
                <div className={`${styles.invisibleCard}`}></div>
                <h2 className={`col`}>Поделись персональным промокодом с пятью новыми игроками и получи одну бесплатную игру </h2>
            </div>
            <div className={`row g-0 ${styles.cards} ${styles.inputWrapper}`}>
                <div className={`${styles.invisibleCard}`}></div>
                <div
                    className={`${styles.input} ${styles.invisibleCard}`}
                    onClick={() => {
                        toast.success("Промокод скопирован")
                        navigator.clipboard.writeText(code)}
                }
                >
                    <h3>{code}</h3>
                    <img className={styles.copyImg} src={copy} alt="Копировать"/>
                </div>
                <h3 className = {`col-auto`}>Ваш промокод был активирован: {count} {pluralize(count, ['раз','раза', 'раз'])}</h3>
            </div>
        </section>
    )
}